// function cartCheckboxes() {

// const submitButton = document.querySelector(".cart-footer [name='checkout']")
// const checkboxes = document.querySelectorAll('.cart_checkboxes input')
// const form = document.querySelector('.cart-container')
      
//   function isAllChecked() {
//     for (var i = 0; i < checkboxes.length; i++) {
//       if (!checkboxes[i].checked) {
//         return true;
//         break;
//       }
//     }
//     return false;
//   } 

//   function changeButtonAttribute() {
//     checkboxes.forEach(e => {
//       if (isAllChecked()) {
//         submitButton.setAttribute("disabled", "disabled")
//       } else {
//         submitButton.removeAttribute("disabled")
//       }
//     })
//   }

//   changeButtonAttribute()

//   checkboxes.forEach(e => {
//     e.onchange = () => {
//          changeButtonAttribute()
//     }
//   })
// }



//   cartCheckboxes()
window.onload = function() {
  console.log("On load");
  const priceHeader = document.querySelector('.product-header-mobile .product-price.product-main-price');
  if (priceHeader != null) {
  	const defaultOffset = priceHeader.offsetTop;
    const defaultHeight = priceHeader.clientHeight;
    const siteHeader = document.querySelector('.site-header.site-navigation-layout-drawer').clientHeight;
    checkPriceStickiness(priceHeader, defaultOffset, defaultHeight, siteHeader);
    window.onscroll = function() {
      checkPriceStickiness(priceHeader, defaultOffset, defaultHeight, siteHeader);
    }
  }
  function checkPriceStickiness(priceHeader, defaultOffset, defaultHeight, siteHeader) {
    if (defaultOffset <= window.scrollY) {
      priceHeader.parentElement.style.paddingBottom = `${defaultHeight}px`;
      priceHeader.classList.add('price-sticky');
      priceHeader.style.top = `${siteHeader}px`;
    }
    else {
      priceHeader.classList.remove('price-sticky');
      priceHeader.parentElement.style.paddingBottom = ``;
      priceHeader.style.top = ``;
    }
  }
}

$(document).on("click", function(e) {
	let myTargetElement = e.target;
    if($(myTargetElement).hasClass("shg-gallery-thumb-image")) {
      switch($(myTargetElement).parent().index()) {
        case 0:
          $(".shg-product-variant-select:first").val("Black");
          break;
        case 1:
          $(".shg-product-variant-select:first").val("Green");
          break;
        case 2:
          $(".shg-product-variant-select:first").val("Blue");
          break;
        case 3:
          $(".shg-product-variant-select:first").val("White");
          break;
      }
      
      let custom_select = document.querySelector('.shg-product-variant-select');
      
      custom_select.dispatchEvent(new Event('change'));
    }
});


$(".finance-apply").click(function(e) {
  
  if($("select[name='Select payment plan']").val() == '' || !$("select[name='Select payment plan']").val()) {
  	alert("Please select payment plan!");
    return;
  } else {
    console.log(document.location.href, 'document.location.href');
    setTimeout(function() {
      
      document.location.href = "/pages/finance-form";
    }, 250);
  }
  
});

$(".buy_to_cart").click(function() {
  setTimeout(function() {
    document.location.href = "/cart";
  }, 250);
});

$("select[name='Select payment plan']").change(function() {

  localStorage.setItem('p-payment-plan', $(this).val());
});